import React from 'react';
import clsx from 'clsx';
import { T, Tooltip } from '@colonist/ui';
import styles from './StatsGrid.module.scss';
const UNKNOWN_STAT = '?';
const UNKNOWN_KARMA = '?/?';
export const StatsGrid = ({ stats })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.statsContainer
    }, /*#__PURE__*/ React.createElement(StatCell, {
        rowVariant: "top",
        titleKey: "strings:profilePage.overview.table.totalGames.title",
        tooltipKey: "strings:profilePage.overview.table.totalGames.tooltip",
        value: stats == undefined ? UNKNOWN_STAT : stats.totalGames
    }), /*#__PURE__*/ React.createElement(StatCell, {
        rowVariant: "top",
        titleKey: "strings:profilePage.overview.table.winPercentage.title",
        tooltipKey: "strings:profilePage.overview.table.winPercentage.tooltip",
        value: stats == undefined ? UNKNOWN_STAT : stats.winPercent
    }), /*#__PURE__*/ React.createElement(StatCell, {
        rowVariant: "bottom",
        titleKey: "strings:profilePage.overview.table.karma.title",
        tooltipKey: "strings:profilePage.overview.table.karma.tooltip",
        value: stats == undefined ? UNKNOWN_KARMA : stats.karma
    }), /*#__PURE__*/ React.createElement(StatCell, {
        rowVariant: "bottom",
        titleKey: "strings:profilePage.overview.table.pointsPerGame.title",
        tooltipKey: "strings:profilePage.overview.table.pointsPerGame.tooltip",
        value: stats == undefined ? UNKNOWN_STAT : stats.pointsPerGame
    }), /*#__PURE__*/ React.createElement(StatCell, {
        rowVariant: "bottom",
        titleKey: "strings:profilePage.overview.table.points.title",
        tooltipKey: "strings:profilePage.overview.table.points.tooltip",
        value: stats == undefined ? UNKNOWN_STAT : stats.pointsInLast100Games
    }));
};
const StatCell = ({ rowVariant, titleKey, tooltipKey, value })=>{
    const rowClassName = rowVariant == 'top' ? styles.statCellTopRow : styles.statCellBottomRow;
    return /*#__PURE__*/ React.createElement(Tooltip, {
        content: /*#__PURE__*/ React.createElement(T, {
            id: {
                key: tooltipKey
            }
        }),
        className: clsx(styles.statCell, rowClassName)
    }, /*#__PURE__*/ React.createElement("h3", {
        className: styles.statTitle
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: titleKey
        }
    })), /*#__PURE__*/ React.createElement("h3", {
        className: styles.statValue
    }, value));
};
